import axios from "axios";
import Pack_Courses from "./Pack_Courses.class";


/**
 * @classdesc Liste des packs de courses d'un module
 * @kind class
 * @export
 * @prop {int} id_module - Id du module
 * @prop {array} list - Liste des packs
 * @class List_Packs_Courses
 */
export default class List_Packs_Courses {
    id_module;
    list = [];

    /**
     *  Initialise la liste des packs
     *
     * @constructs
     * @memberof List_Packs_Courses
     */
    constructor(id) {
        this.id_module = id;
    }

    /**
     * Appel API pour charger la liste
     *
     * @return {boolean} success
     * @async
     * @memberof List_Packs_Courses
     */
    async fetch() {
        this.list = [];
        let res = await axios.get("/packs_courses/get.php?id_module=" + this.id_module);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    /**
 *  Initialise la liste des packs
 * @param {boolean} admin_view  - Si l'utilisateur est admin
 * @param {boolean} admin_ins  - Si l'utilisateur est admin
 */
    async initialize(admin_view, admin_ins) {
        if (this.list.length == 0) {
            if (admin_view || admin_ins) {
                await this.fetch(); // Charge tous les packs
            } else {
                await this.fetch("open"); // Charge les packs ouverts
            }
        }
        else {
            //await this.refresh_nb_inscrits();
        }
    }

    initialize_from_mainstore(packs) {
        if (this.has_packs()) {
            return;
        }
        for (let i = 0; i < packs.length; i++) {
            let pack = new Pack_Courses();
            pack.set(packs[i]);
            this.list.push(pack);
        }
    }



    /**
     * Créer la liste des packs d'un module
     *
     * @param {array} data
     * @memberof List_Packs_Courses
     */
    set(data) {
        this.list = [];
        for (let i = 0; i < data.length; i++) {
            let pack = new Pack_Courses();
            pack.set(data[i]);
            this.list.push(pack);
        }
    }

    update_from_course_selection(courses) {
        for (let i = 0; i < this.list.length; i++) {
            this.list[i].update_from_course_selection(courses);
        }
    }

    update_cart(lien_groupe = null) {
        let cart = { nb_articles: 0, prix: 0 };
        for (let i = 0; i < this.list.length; i++) {
            let item_cart = this.list[i].update_cart(lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles);
            cart.prix += parseFloat(item_cart.prix);
        }

        this.cart = cart;
        return cart;
    }

    get_list_choix() {
        let list_choix = this.list.map(item => {
            let choix = {};
            choix.id = item.id;
            choix.value = item.nom;
            choix.selected = false;
            return choix;
        });
        return list_choix;
    }

    /* ------------------------ */
    get_selected_packs() {
        return this.list.filter(pack => pack.selected);
    }

    has_packs() {
        return this.list.length > 0;
    }

    getSimplifiedData() {
        if (this.cart?.nb_articles == 0) return null;
        let infos = {};
        infos.prix = this?.cart?.prix;
        infos.list = [];
        for (let i = 0; i < this.list.length; i++) {
            const pack = this.list[i];
            let pack_infos = pack.getSimplifiedData();
            if (pack_infos) {
                infos.list.push(pack_infos);
            }
        }
        return infos;
    }




}
